import { createFeatureSelector, createSelector } from '@ngrx/store';

import { BUSINESS_CARD_FEATURE_KEY, BusinessCardState } from './business-card.reducer';

export const getBusinessCardState = createFeatureSelector<BusinessCardState>(BUSINESS_CARD_FEATURE_KEY);
export const getBusinessCard = createSelector(getBusinessCardState, (state: BusinessCardState) => state.businessCard);
export const isBusinessCardLoaded = createSelector(getBusinessCardState, (state: BusinessCardState) => state.loaded);
